import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46004f45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-name" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "field-grid-control",
    style: _normalizeStyle(_ctx.grid)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.properties, (prop) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: prop.id
      }, [
        _createElementVNode("div", {
          class: "field-info",
          style: _normalizeStyle(_ctx.propTitleGridStyle(prop))
        }, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(prop.name), 1),
          (prop.help)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "field-help",
                href: prop.help,
                target: "”_blank”"
              }, "", 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 4),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getField(prop)), {
          class: "field-value",
          style: _normalizeStyle(_ctx.propFieldGridStyle(prop)),
          property: prop,
          onExecute: _cache[0] || (_cache[0] = c => _ctx.$emit('execute', c))
        }, null, 40, ["style", "property"]))
      ], 64))
    }), 128))
  ], 4))
}